import {
  confirmCustomer,
  CreatableCustomer,
  createCustomer,
  getCustomer,
  login,
  logout,
  ModifiableCustomer,
  updateCustomer,
  deleteCustomer,
} from '@ttstr/api';
import { loadCart } from './cart';
import { ThunkActionCreator } from '.';

export const LOGIN_REQUESTED = 'CUSTOMER.LOGIN_REQUESTED';
export const LOGIN_RECEIVED = 'CUSTOMER.LOGIN_RECEIVED';
export const LOGIN_RECEIVE_FAILED = 'CUSTOMER.LOGIN_RECEIVE_FAILED';
export const LOGIN_RECEIVE_DONE = 'CUSTOMER.LOGIN_RECEIVE_DONE';

export const LOGOUT_REQUESTED = 'CUSTOMER.LOGOUT_REQUESTED';
export const LOGOUT_RECEIVED = 'CUSTOMER.LOGOUT_RECEIVED';
export const LOGOUT_RECEIVE_FAILED = 'CUSTOMER.LOGOUT_RECEIVE_FAILED';
export const LOGOUT_RECEIVE_DONE = 'CUSTOMER.LOGOUT_RECEIVE_DONE';

export const CUSTOMER_REQUESTED = 'CUSTOMER.CUSTOMER_REQUESTED';
export const CUSTOMER_RECEIVED = 'CUSTOMER.CUSTOMER_RECEIVED';
export const CUSTOMER_RECEIVE_FAILED = 'CUSTOMER.CUSTOMER_RECEIVE_FAILED';
export const CUSTOMER_RECEIVE_DONE = 'CUSTOMER.CUSTOMER_RECEIVE_DONE';

export const CUSTOMER_UPDATE_REQUESTED = 'CUSTOMER.CUSTOMER_UPDATE_REQUESTED';
export const CUSTOMER_UPDATED = 'CUSTOMER.CUSTOMER_UPDATED';
export const CUSTOMER_UPDATE_FAILED = 'CUSTOMER.CUSTOMER_UPDATE_FAILED';
export const CUSTOMER_UPDATE_DONE = 'CUSTOMER.CUSTOMER_UPDATE_DONE';

export const CUSTOMER_CREATE_REQUESTED = 'CUSTOMER.CUSTOMER_CREATE_REQUESTED';
export const CUSTOMER_CREATED = 'CUSTOMER.CUSTOMER_CREATED';
export const CUSTOMER_CREATE_FAILED = 'CUSTOMER.CUSTOMER_CREATE_FAILED';
export const CUSTOMER_CREATE_DONE = 'CUSTOMER.CUSTOMER_CREATE_DONE';

export const CUSTOMER_CONFIRM_REQUESTED = 'CUSTOMER.CUSTOMER_CONFIRM_REQUESTED';
export const CUSTOMER_CONFIRMED = 'CUSTOMER.CUSTOMER_CONFIRMED';
export const CUSTOMER_CONFIRM_FAILED = 'CUSTOMER.CUSTOMER_CONFIRM_FAILED';
export const CUSTOMER_CONFIRM_DONE = 'CUSTOMER.CUSTOMER_CONFIRM_DONE';

export const CUSTOMER_DELETE_REQUESTED = 'CUSTOMER.CUSTOMER_DELETE_REQUESTED';
export const CUSTOMER_DELETED = 'CUSTOMER.CUSTOMER_DELETED';
export const CUSTOMER_DELETE_FAILED = 'CUSTOMER.CUSTOMER_DELETE_FAILED';
export const CUSTOMER_DELETE_DONE = 'CUSTOMER.CUSTOMER_DELETE_DONE';

export const requestLogin: ThunkActionCreator = (username: string, password: string) => async (dispatch) => {
  dispatch({
    type: LOGIN_REQUESTED,
  });

  try {
    await login(username, password);
    dispatch({
      type: LOGIN_RECEIVED,
    });
    await Promise.all([dispatch(requestCustomer()), dispatch(loadCart())]);
  } catch (error) {
    dispatch({
      type: LOGIN_RECEIVE_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: LOGIN_RECEIVE_DONE,
    });
  }
};

export const requestLogout: ThunkActionCreator = () => async (dispatch) => {
  dispatch({
    type: LOGOUT_REQUESTED,
  });

  try {
    await logout();
    dispatch({
      type: LOGOUT_RECEIVED,
    });
  } catch (error) {
    dispatch({
      type: LOGOUT_RECEIVE_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: LOGOUT_RECEIVE_DONE,
    });
  }
};

export const requestCustomer: ThunkActionCreator = () => async (dispatch) => {
  dispatch({
    type: CUSTOMER_REQUESTED,
  });

  try {
    const customer = await getCustomer();
    dispatch({
      type: CUSTOMER_RECEIVED,
      payload: {
        customer,
      },
    });
  } catch (error) {
    dispatch({
      type: CUSTOMER_RECEIVE_FAILED,
      payload: {
        error,
      },
    });
    // re-trow
    throw error;
  } finally {
    dispatch({
      type: CUSTOMER_RECEIVE_DONE,
    });
  }
};

export const requestUpdateCustomer: ThunkActionCreator = (customer: ModifiableCustomer) => async (dispatch) => {
  dispatch({
    type: CUSTOMER_UPDATE_REQUESTED,
  });

  try {
    const updatedCustomer = await updateCustomer(customer);
    dispatch({
      type: CUSTOMER_UPDATED,
      payload: {
        customer: updatedCustomer,
      },
    });
  } catch (error) {
    dispatch({
      type: CUSTOMER_UPDATE_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: CUSTOMER_UPDATE_DONE,
    });
  }
};

export const requestCreateCustomer: ThunkActionCreator = (customer: CreatableCustomer) => async (dispatch) => {
  dispatch({
    type: CUSTOMER_CREATE_REQUESTED,
  });

  try {
    const updatedCustomer = await createCustomer(customer);
    dispatch({
      type: CUSTOMER_CREATED,
      payload: {
        customer: updatedCustomer,
      },
    });
  } catch (error) {
    dispatch({
      type: CUSTOMER_CREATE_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: CUSTOMER_CREATE_DONE,
    });
  }
};

export const requestConfirmCustomer: ThunkActionCreator = (token: string) => async (dispatch) => {
  dispatch({
    type: CUSTOMER_CONFIRM_REQUESTED,
  });

  try {
    await confirmCustomer(token);
    dispatch({
      type: CUSTOMER_CONFIRMED,
    });
  } catch (error) {
    dispatch({
      type: CUSTOMER_CONFIRM_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: CUSTOMER_CONFIRM_DONE,
    });
  }
};

export const requestDeleteCustomer: ThunkActionCreator = () => async (dispatch) => {
  dispatch({
    type: CUSTOMER_DELETE_REQUESTED,
  });

  try {
    await deleteCustomer();
    dispatch({
      type: CUSTOMER_DELETED,
    });
  } catch (error) {
    dispatch({
      type: CUSTOMER_DELETE_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: CUSTOMER_CONFIRM_DONE,
    });
  }
};